/**
 * Formato único de notas/promedios para todo el módulo de alertas genéricas:
 * se trunca (no redondea) al primer decimal y ese decimal siempre se muestra
 * (3.75 -> "3.7", 5 -> "5.0").
 */

const EPSILON = 1e-9;

/**
 * Trunca un valor al primer decimal como número (para cálculos/export a
 * Excel). Un epsilon evita que el ruido de punto flotante de divisiones
 * (p. ej. `valor / maximo * 5`) trunque un decimal de menos.
 * Devuelve `null` si el valor no es un número finito.
 */
export const truncarNota = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.trunc(n * 10 + EPSILON) / 10;
};

/** Como `truncarNota`, pero como texto listo para mostrar en la UI. */
export const formatNota = (value, fallback = "—") => {
  const truncado = truncarNota(value);
  return truncado === null ? fallback : truncado.toFixed(1);
};
